import { Button as MuiButton } from "@material-ui/core";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React from "react";
type Props = {
  children: any;
  style: "submit" | "save" | "approve" | "reject" | "decline";
  type: "button" | "reset" | "submit";
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  className?: string;
};

const useStyles = makeThemedStyles("FormButton", (theme) => ({
  submitButton: {
    backgroundColor: "#00A9A3",
    borderRadius: "26px",
    color: "#fff",
    width: "195px",
    height: "40px",
    "& .MuiButton-label": {
      fontSize: "14px",
    },
    "&.MuiButton-root:hover": {
      backgroundColor: "#115e67",
    },
  },
  saveButton: {
    background: "rgb(224, 168, 10)",
    "&.MuiButton-root:hover": {
      backgroundColor: "rgba(224, 168, 10, 0.7)",
    },
  },
  approveButton: {
    background: "rgb(0, 169, 163)",
    "&.MuiButton-root:hover": {
      backgroundColor: "rgb(0, 169, 163, 0.7)",
    },
  },
  rejectButton: {
    background: "rgb(126, 135, 145)",
    "&.MuiButton-root:hover": {
      backgroundColor: "rgb(126, 135, 145, 0.7)",
    },
  },
  declineButton: {
    background: "rgb(226, 35, 45)",
    "&.MuiButton-root:hover": {
      backgroundColor: "rgb(126, 135, 145, 0.7)",
    },
  },
}));

const FormButton = (props: Props) => {
  const classes = useStyles();
  const pickStyle =
    props.style === "approve"
      ? classes.approveButton
      : props.style === "reject"
      ? classes.rejectButton
      : props.style === "decline"
      ? classes.declineButton
      : props.style === "save"
      ? classes.saveButton
      : "";
  return (
    <MuiButton
      type={props.type}
      className={`${classes.submitButton} ${props.className} ${pickStyle}`}
      onClick={props.onClick}
    >
      {props.children}
    </MuiButton>
  );
};

export default FormButton;
